<template>
  <section id="Fotobox" class="text-light" style="background-color: dimgray">
    <div class="container py-5">
      <div class="row mt-5">
        <div class="col-12 text-center">
          <h2 class="mb-5" data-aos="fade-up" data-aos-delay="500">Fotobox</h2>
          <p data-aos="fade-up" data-aos-delay="500">Das besondere Highlight für Events aller Art!</p>
          <p data-aos="fade-up" data-aos-delay="500">Ihr sucht noch etwas ganz Besonderes für eure Hochzeit, Geburtstag oder Firmen Event?</p>
          <p data-aos="fade-up" data-aos-delay="500">Etwas das dieses Event zu etwas ganz Besonderem macht?</p>
          <p data-aos="fade-up" data-aos-delay="500">Dann empfehle ich euch meine leicht zu bedienende Fotobox durch ein 20“ großen Touchscreen Bildschirm & Funk-Buzzer.</p>
          <p data-aos="fade-up" data-aos-delay="500">Bei den Gästen sorgt sie für Spaß, gute Unterhaltung und es entstehen spontane unvergessliche Erinnerungsbilder.</p>
          <p data-aos="fade-up" data-aos-delay="500">2 Hintergrund-Systeme, große Auswahl an bereitgestellte qualitative Verkleidungsutensilien (Brillen, Hüte, Perücken…), hochauflösende Fotos zum Sofortausdruck, professionelle Kamera für ein digitales Foto.</p>
        </div>
      </div>
      <div class="row g-5 my-5 justify-content-center pb-5">
        <div class="col-md-6" data-aos="fade-up" data-aos-delay="500">
          <img class="foto" src="@/assets/img/fotobox4.jpeg">
        </div>
        <div class="col-md-6" data-aos="fade-up" data-aos-delay="500">
          <img class="foto" src="@/assets/img/fotobox5.jpeg">
        </div>
        <div class="col-xl-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
          <img class="foto" src="@/assets/img/fotobox1.jpg">
        </div>
        <div class="col-xl-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
          <img class="foto" src="@/assets/img/fotobox2.png">
        </div>
        <div class="col-xl-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
          <img class="foto" src="@/assets/img/fotobox3.jpg">
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

</script>

<style scoped>
.foto {
  border-radius: 10px;
  width: 100%;
  transition: 0.5s;
}
.foto:hover {
  transform: scale(110%);
}
</style>